'use client';

import dynamic from 'next/dynamic';
import { ScrollArea } from '@mantine/core';

const CameraDetails = dynamic(
  () => import('./cameradetails'),
  { ssr: false, loading: () => <p>Loading Camera...</p> }
);

const WebGPUChecker = dynamic(
  () => import('./webgpudetails'),
  { ssr: false, loading: () => <p>Loading WebGPU...</p> }
);



export default function Page() {
  return (
    <div
      style={{
        height: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <ScrollArea
        style={{
          flex: 1,
          minHeight: 0,
        }}
      >
        <div style={{ padding: 8 }}>
          <h2 style={{ paddingLeft: 8 }}>Cameras</h2>
          <CameraDetails />

          <h2 style={{ paddingLeft: 8, marginTop: 16 }}>WebGPU</h2>
          <WebGPUChecker />
        </div>
      </ScrollArea>
    </div>
  );
}